export const orthoticStylesArray = [
	'Functional Orthotics',
	'Dress',
	'Sport',
	'Sport (low profile)',
	'Everyday Comfort - Met Length Shell',
	'Everyday Comfort - Sulcus Length Shell',
	'Everyday Comfort - Full Length Shell',
	'Accommodative',
	'Flatfoot',
	'UCBL'
] as const;
export default orthoticStylesArray;
export type OrthoticStyle = typeof orthoticStylesArray[number];

export interface ProductStyle {
	name?: string;
	title: OrthoticStyle;
	desc: string;
	src: string;
}
export const PRODUCTS: ProductStyle[] = [
	{
		title: orthoticStylesArray[0],
		desc: '',
		src: require('@/assets/order-styles/orthotic-functional.png')
	},
	{
		title: orthoticStylesArray[1],
		desc: 'Slim profile designed specifically for dress and low profile footwear.',
		src: require('@/assets/order-styles/orthotic-dress.png')
	},
	{
		name: 'Athletics/Sports',
		title: orthoticStylesArray[2],
		desc: 'Improve support and stability during sports and other strenuous activities.',
		src: require('@/assets/order-styles/orthotic-athletic.png')
	},
	{
		name: 'Athletics/Sports',
		title: orthoticStylesArray[3],
		desc: 'Improve support and stability during sports and other strenuous activities.',
		src: require('@/assets/order-styles/orthotic-athletic.png')
	},
	{
		title: orthoticStylesArray[4],
		desc: 'Reduce foot pain and stay active all day with our everyday comfort orthotic.',
		src: require('@/assets/order-styles/orthotic-comfort.png')
	},
	{
		title: orthoticStylesArray[5],
		desc: 'Reduce foot pain and stay active all day with our everyday comfort orthotic.',
		src: require('@/assets/order-styles/orthotic-comfort.png')
	},
	{
		title: orthoticStylesArray[6],
		desc: 'Reduce foot pain and stay active all day with our everyday comfort orthotic.',
		src: require('@/assets/order-styles/orthotic-comfort.png')
	},
	{
		title: orthoticStylesArray[7],
		desc: '',
		src: require('@/assets/order-styles/orthotic-functional.png')
	},
	{
		title: orthoticStylesArray[8],
		desc: '',
		src: require('@/assets/order-styles/orthotic-functional.png')
	},
	{
		title: orthoticStylesArray[9],
		desc: '',
		src: require('@/assets/order-styles/orthotic-functional.png')
	}
];

Object.freeze(PRODUCTS);
